// Modules
import React from "react";

function AccordionMenu ({ hasIcon, onRowClicked, onToggle, PageLevel= 0, SubLevel = 0, Icon,label, wrapperStyles, labelStyles }) {
	// render icon if children has a length > 0
	// except hamburger Icon
	return (
		<div className={`w-full p-5 flex justify-between ${wrapperStyles}`} onClick={onRowClicked}>
			<div className={labelStyles}>{label}</div>
			<div>
				{hasIcon &&
					<button onClick={onToggle}>
						{Icon}
					</button>}
			</div>
		</div>
	);
};

// Export
export default AccordionMenu;
